<template>
  <div style="display:flex;flex-wrap:wrap; ">
    <a-card size="small" :title="s.name" style="width: 300px;margin:10px" v-for="s in ships" :key="s.id">
      <div slot="extra">
        Sync
        <a-switch size="small" v-model="s.sync" @change="e=>change_sync(e,s.shipid)" />
      </div>
      <p>MMSI:{{s.mmsi}}</p>
      <p>ShipID:{{s.shipid}}</p>
      <p>Call Sign: {{s.callsign}}</p>
      <p>Ship Type: {{s.shiptype_name}}</p>
      <a-popconfirm style="float:right" title="Are you sure delete?" @confirm="del_ship(s.shipid)" okText="Yes" cancelText="No">
        <a href="#">Delete</a>
      </a-popconfirm>
    </a-card>

  </div>
</template>


<script>


export default {
  data() {
    return {
      ships: []
    }
  },
  methods: {
    refresh() {
      this.$http.post(this.$store.state.base_url + "/ship/r", {}).then(res => {
        if (res.data.status == 1) {
          this.ships = res.data.data
          var num = 0 
        }
      })
    },


    del_ship(id) {
      this.$http.post(this.$store.state.base_url + "/ship/d", {shipid:id}).then(res=>{
        if(res.data.status==1){
          this.refresh()
        }
      })
    },

    change_sync(e,id) {
      this.$http.post(this.$store.state.base_url + "/ship/u", { shipid: id,sync:e}).then(res => {
          if(res.data.status==1){
              this.refresh()
          }
      })
    }
  },
  mounted() {
    this.refresh()

  }
};
</script>
<style scoped>
</style>